import Paths from "@/constants/paths";

export const defaultPagePerRoleBo = [
  { label: "ADMIN", value: Paths.bo.expeditionsHistoryV2 },
  { label: "SUPERADMIN", value: Paths.bo.expeditionsHistoryV2 },
  { label: "DRIVER", value: Paths.bo.collection },
  { label: "MEMBER", value: Paths.bo.expeditionsHistoryV2 },
  { label: "ACCOUNTANT", value: Paths.bo.invoices },
  { label: "PACKER", value: Paths.bo.packaging },
];

export const defaultPagePerRole = [
  { label: "ADMIN", value: Paths.home.cotations },
  { label: "SUPERADMIN", value: Paths.home.cotations },
  { label: "MEMBER", value: Paths.home.cotations },
  { label: "ACCOUNTANT", value: Paths.home.invoices },
];

export const getDefaultPagePerRoleBo = (role?: string) => {
  return (
    defaultPagePerRoleBo.find(({ label }) => label === role)?.value ||
    `${Paths.bo.expeditionsBox}?week=false`
  );
};

export const getDefaultPagePerRole = (role?: string) => {
  return defaultPagePerRole.find(({ label }) => label === role)?.value || Paths.home.cotations;
};

export const getDefaultPageForUser = (role?: string, isBoUser?: boolean) => {
  return isBoUser ? getDefaultPagePerRoleBo(role) : getDefaultPagePerRole(role);
};
